import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=12c32963"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ImpersonationBanner.vue?vue&type=style&index=0&id=12c32963&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports